import React from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {resetFilters, setContentType, setCategory} from "../store/filtersSlice";

interface DropdownProps {
  title: string;
  links: {label: string; category: string; content_type: "movie" | "tv"}[];
}

export const DropDown: React.FC<DropdownProps> = ({title, links}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dropdownHandle = (category: string, content_type: "movie" | "tv") => {
    dispatch(resetFilters());
    dispatch(setContentType(content_type));
    dispatch(setCategory(category));
    navigate(`/movflix/discover/${content_type}?category=${category}`);
  };

  return (
    <div className="relative group">
      <button className="flex items-center gap-1 h-9 px-3 text-[13px] font-medium text-t2 bg-transparent border-none transition-colors duration-fast hover:text-t1 group-hover:text-t1">
        {title}
        <svg
          width="11"
          height="11"
          viewBox="0 0 12 12"
          fill="none"
          className="transition-transform duration-fast group-hover:rotate-180 mt-px"
        >
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* Invisible bridge fills the gap so hover isn't lost when moving to the panel */}
      <div className="absolute top-full left-0 w-full h-2 hidden group-hover:block" />

      <div className="absolute top-[calc(100%+8px)] left-0 min-w-[160px] bg-raised border border-border2 rounded-md py-1 z-[300] shadow-lg hidden group-hover:block">
        {links.map((link, index) => (
          <button
            key={index}
            onClick={() => dropdownHandle(link.category, link.content_type)}
            className="block w-full px-4 py-2.5 text-left text-[13px] font-medium text-t2 bg-transparent border-none transition-colors duration-fast hover:text-t1 hover:bg-raised2 cursor-pointer"
          >
            {link.label}
          </button>
        ))}
      </div>
    </div>
  );
};
